export const scrollToId = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const MIDDLE_EXPANDED_KEY = "choice-middle-expanded";
